import { observable, action } from 'mobx';
import { Beneficiaries } from 'api';

class BeneficiariesStore {
  @observable beneficiaries = [];

  @observable fetchState;

  anketId;

  @action.bound
  async getBeneficiaries(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Beneficiaries.getBeneficiaries(anketId);
      this.beneficiaries = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const beneficiariesStore = new BeneficiariesStore();

export default beneficiariesStore;
